import ApiService from "../../ApiService";

const DefaultService = {
    loadScreenView: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/talkchinese/default/loadscreenview", vo, successCallback, failureCallback);
    },
    loadBooksView: (successCallback, failureCallback) => {
        ApiService.post("/mobile/talkchinese/default/loadbooksview", {}, successCallback, failureCallback);
    },
    savePlan: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/talkchinese/default/saveplan", vo, successCallback, failureCallback);
    },
    upgradePlan: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/talkchinese/default/upgradeplan", vo, successCallback, failureCallback);
    },
    restartTask: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/talkchinese/default/restarttask", vo, successCallback, failureCallback);
    },
};

export default DefaultService;
